import { stagger } from 'framer-motion';

/**
 * Reward You — dedicated scroll-reveal animation config.
 *
 * The section is animated by imperatively animating existing DOM nodes
 * (see RewardYouSection.js `useAnimate` + `inView`). Keeping the keyframes
 * and timing here means the section's motion lives in one place and can be
 * tuned without touching component or layout code.
 *
 * Layout reminder:
 *  - Block 1 (`#reward-you-section-block-1`) is the left photo column.
 *  - Block 2 (`#reward-you-section-block-2`) has the h2 heading, a `<ul>`
 *    with 4 list items, and a CTA link.
 */

// Custom cubic-bezier: smooth deceleration (similar to easeOutExpo)
export const EASE_OUT = [0.22, 1, 0.36, 1];

// Left photo column: slides in from the left edge.
export const slideInFromLeft = {
  opacity: [0, 1],
  x: [-64, 0],
};

// Heading (and any intro text): rises from below.
export const fadeUpHeading = {
  opacity: [0, 1],
  y: [28, 0],
};

// The 4 list items (icons + copy): fade up from below.
export const fadeUpListItem = {
  opacity: [0, 1],
  y: [24, 0],
};

// CTA link: gentle rise after the list has settled.
export const fadeUpCta = {
  opacity: [0, 1],
  y: [16, 0],
};

// List items reveal one after another (150ms apart) once the section enters.
export const listItemStagger = stagger(0.15, { startDelay: 0.15 });